/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.view.application.entities.list.removeModal.controllers',
  'acme.view.application.entities.list.addModal.controllers',
  'acme.view.application.entities.templates.create.controllers'
])

.controller('EntitiesListController', ['$scope', '$state', '$uibModal', '$filter', '$timeout', 'ApiService', 'PermissionsService', 'HelpersService', 'GridStateFactory', 'GridDefinitionFactory', 'preferenceKey', function($scope, $state, $uibModal, $filter, $timeout, ApiService, PermissionsService, HelpersService, GridStateFactory, GridDefinitionFactory, preferenceKey) {

    $scope.entitiesList = {

      addModal: {},
      removeModal: {},
      currentEntity: {},
      entityType: {},
      selectedTemplates: {},
      cachedSelectedTemplates: {},
      model: [],
      templates: [],
      selected: [],
      filtered: [],
      searchQuery: '',
      searchTemplatesQuery: '',
      filterTypes: '',
      selectedEditType: 'none',

      view: 'list',
      isLoaded: false,
      isListLoaded: false,
      searchTimer: false,
      searchTemplatesTimer: false,
      entitiesGridName: $state.current.name + '.grid0',
      grid: {
        appScopeProvider: {
          onDataGridSortChange: function(grid, columns) {
            $scope.entitiesList.onDataGridSortChange(grid, columns);
          },
          onDataGridPaginate: function(newPageNumber, newPageSize) {
            $scope.entitiesList.onDataGridPaginate(newPageNumber, newPageSize);
          },
          remove: function(row) {
            $scope.entitiesList.remove(row);
          },
          onDblClick: function(row) {
            $scope.entitiesList.gridDoubleClick(row);
          }
        },
        useExternalPagination: true,
        paginationAutoPageSize: true,
        useExternalSorting: true,
        data: 'entitiesList.model',
        multiselect: false,
        enableGridMenu: false,
        enableRowSelection: false,
        pageSize: 25,
        showFooter: true,
        paginate: true,
        columnDefs: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.entitiesList.gridDoubleClick(row);
            },
            cellTemplate: '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          },
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'description',
            displayName: 'Description',
            visible: false
          },
          {
            field: 'title',
            displayName: 'Job Title',
            visible: false
          },
          {
            field: 'department',
            displayName: 'Department',
            visible: false
          }
        ]
      },

      // Not a grid but a containing object for left list
      templatesGrid: {
        totalItems: 0,
        pageSize: 5,
        page: 1
      },

      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      templatesGridState: new GridStateFactory(),

      init: function() {
        var enablePreferences = $state.$current.data && $state.$current.data.enablePreferences;

        this.viewId = [$state.current.name, preferenceKey].join('.');
        this.gridDefinition.init(this.entitiesGridName, this.grid, this.viewId, enablePreferences);
        console.log('EntitiesListController::init', $state.params);

        if ($state.params && $state.params.type) {

          //this.getEntities($.extend({}, { type: $state.params.type }, this.gridState.getGridState()));
          this.getTemplates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, this.templatesGridState.getGridState()));
          this.entityType = HelpersService.getEntityName($state.params.type);
          console.log('EntitiesListController::init', 'ENTITY_'+this.entityType.singular.toUpperCase()+'_CREATE');

          if (!PermissionsService.check('ENTITY_' + this.entityType.singular.toUpperCase() + '_VIEW')) {
            console.log('ENTITY_' + this.entityType.singular.toUpperCase() + '_VIEW');
            $state.go('home.default', {}, { notify: true });
          }

          $scope.$emit('Application::contentTitleChange', {
            title: HelpersService.cap(this.entityType.displayPlural),
            buttonRight: {
              label: '+ Add ' + HelpersService.cap(this.entityType.displayPlural),
              opensDialog: true,
              permissions: 'ENTITY_'+this.entityType.singular.toUpperCase()+'_CREATE',
              action: function() {
                $scope.entitiesList.addEntity();
              }
            }
          });

          $scope.$emit('AppController::updateTitle', {
            title: HelpersService.cap(this.entityType.displayPlural)
          });


          if (PermissionsService.check('ENTITY_'+this.entityType.singular.toUpperCase()+'_DELETE')) {
            this.grid.columnDefs.push({
              field: 'remove',
              displayName: 'Remove',
              enableHiding: false,
              enableSorting: false,
              onCellNavClick: function(row, col) {
                if (PermissionsService.check('ENTITY_'+$scope.entitiesList.entityType.singular.toUpperCase()+'_DELETE') ) {
                  $scope.entitiesList.remove(row.entity.id);
                }
              },
              cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>'
            });
          }
          if (this.entityType.singular === 'personnel') {
            this.grid.columnDefs[2].visible = true;
            this.grid.columnDefs[3].visible = true;
          }else{
            this.grid.columnDefs[1].visible = true;
          }

        }

        $scope.$on('EntitiesTemplatesCreate::Create', this.onEntitiesTemplatesCreateCreate);
        $scope.$on('EntitiesTemplatesCreate::Update', this.onEntitiesTemplatesCreateUpdate);
        $scope.$on('EntitiesTemplatesCreate::Cancel', this.onEntitiesTemplatesCreateCancel);
        //$scope.$on('$destroy', $scope.$watch('entitiesList.searchTemplatesQuery', this.onSearchTemplatesQueryUpdate));
        //
        $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      },

      initData: function() {
        var self = $scope.entitiesList, props = self.gridDefinition.getGridState();
        self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.templatesGridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
        self.getQuery();
      },

      createType: function() {
        this.clearSelectedTemplates();
        $scope.$broadcast('EntitiesListController::CreateType', {
          entityType: this.entityType
        });
      },

      editTypes: function(e, templateId) {

        if (e) {
          e.stopPropagation();
        }

        switch(this.entityType.singular) {
          case 'personnel':
            /* falls through */
          case 'facility':
            /* falls through */
          case 'equipment':
            this.selectedEditType = this.entityType.singular;
            this.cachedSelectedTemplates = angular.copy(this.selectedTemplates);
            this.clearSelectedTemplates();
              $timeout(function() {
                var self = $scope.entitiesList;
                if (self.templates.length) {
                  if (templateId) {
                    self.toggleTemplate(templateId);
                  }else {
                    self.toggleTemplate(self.templates[0].id);
                  }
                }else{
                  self.createType();
                }
              }, 0);
            break;
          default:
            this.selectedEditType = 'none';
        }
      },

      isEditType: function(type) {
        return (this.selectedEditType === type);
      },

      editTypesDone: function() {
        this.clearSelectedTemplates();
        this.selectedEditType = 'none';
        this.selectedTemplates = angular.copy(this.cachedSelectedTemplates);
        this.filterTypes = '';
        this.getQuery();
      },

      showMore: function() {
        this.templatesGrid.page += 1;
        this.templatesGridState.updateGridState(this.templatesGrid.page, this.templatesGrid.pageSize);
        this.getTemplates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, this.templatesGridState.getGridState()));
      },

      setView: function(view) {
        var name = 'application';

        this.view = view;

        name += (this.view === 'grid') ? ' application-entities' : '';
        $scope.$emit('AppController::updatePageClass', { name: name });
      },

      isView: function(view) {
        return (this.view === view);
      },

      search: function() {
        console.log('Model: '+JSON.stringify(this.model));
        this.filtered = $filter('filter')(this.model, function(entity) {
          var name = entity.name || '',
            value = (name).toLowerCase();
          console.log('EntitiesListController::search', entity.name, $scope.entitiesList.searchQuery, (value.indexOf($scope.entitiesList.searchQuery.toLowerCase()) !== -1));
          return (value.indexOf($scope.entitiesList.searchQuery.toLowerCase()) !== -1) ? entity : null;
        });
      },

      findEntity: function(id) {

        var i, ii,
            r = false;
        for (i = 0, ii = this.model.length; i < ii; i++) {
          if (id === this.model[i].id) {
            r = {
              index: i,
              entity: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      remove: function(id, type) {
        var self = $scope.entitiesList,
            found = self.findEntity(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/entities/list/modals/remove.tpl.html',
          size: 'md',
          controller: 'EntitiesListRemoveModalController',
          resolve: {
            entity: function() {
              return found.entity;
            },
            entityType: function() {
              return self.entityType;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          self.removeFoundEntity(found);
          self.grid.totalItems -= 1;
        }, function () {
          // Do nothing
        });

      },

      // Uses a found object to perform removal returned by findEntity()
      removeFoundEntity: function(found) {
        var self = $scope.entitiesList;

        ApiService.entity.remove({
          id: found.entity.id,
          type: self.entityType.plural
        }).then(function (response) {
          self.model.splice(found.index, 1);
          self.success.remove(response);
          self.getQuery();
        }, self.error.remove);
      },

      hasSelected: function() {
        return (this.selected.length > 0);
      },

      hasEntities: function() {
        return (this.model.length > 0);
      },

      hasFiltered: function() {
        return (this.filtered.length > 0);
      },

      getTemplates: function(props) {
        ApiService.resource.templates(props).then(this.success.getTemplates, this.error.getTemplates);
      },

      getEntities: function(props) {
        console.log('ResourcesFacilitiesController::getEntities');
        ApiService.entity.list(props).then(this.success.getEntities, this.error.getEntities);
      },

      getQuery: function() {

        var self = $scope.entitiesList,
            query = self.gridState.getGridState();

        this.isLoaded = false;

        query = HelpersService.decorate(query, {
          search: this.searchQuery,
          type: $state.params.type,
          resourceCategoryIds: this.filterTypes
        });

        self.getEntities(query);

      },

      getTemplatesQuery: function() {

        var self = $scope.entitiesList,
          query = self.templatesGridState.getGridState();

        this.isListLoaded = false;
        this.templatesGrid.page = 1;
        this.templatesGridState.setPropertyValue('page', this.templatesGrid.page);

        HelpersService.decorate(query, {
          search: this.searchTemplatesQuery,
          page: this.templatesGrid.page
        });

        if (this.searchTemplatesTimer) {
          $timeout.cancel(this.searchTemplatesTimer);
        }

        this.searchTemplatesTimer = $timeout(function () {
          self.getTemplates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, self.templatesGridState.getGridState()));
        }, 500);

      },

      getEntityViewPermissions: function() {
        return 'ENTITY_' + this.entityType.singular.toUpperCase() + '_VIEW';
      },

      getEntityTemplateViewPermissions: function() {
        return 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_VIEW';
      },

      getTypeName: function() {
        var r;

        if (this.entityType.singular === 'personnel') {
          r = 'Role';
        }else{
          r = 'Type';
        }

        return r;
      },

      getImage: function(image) {
        var r;

        if (image) {
          r = image;
        }else{
          r = '09728cd8-2be9-4966-8ca3-7cfe0ef9e5c9';
        }

        return r;
      },

      getPermission: function(entityType) {
        return 'ENTITY_TEMPLATE_'+entityType.toUpperCase()+'_VIEW';
      },


      addEntity: function() {

        var self = $scope.entitiesList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/entities/list/modals/create'+HelpersService.cap(self.entityType.plural)+'.tpl.html',
          controller: 'EntitiesListAddModalController',
          resolve: {
            allowCreate: function() {
              return true;
            },

            showUsers: function() {
              return true;
            },

            entityType: function() {
              return self.entityType;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (data) {

          self.currentEntity = data.entity;
          self.success.create(data.response);

        }, function () {
          // Do nothing
        });
      },

      selectAll: function() {
        this.clearSelectedTemplates();
        this.selectedEditType = 'none';
        this.selectedTemplates.all = true;
        this.filterTypes = '';
        this.getQuery();
      },

      isTemplateSelected: function(id) {
        return (this.selectedTemplates[id]);
      },

      toggleTemplate: function(id) {
        var template,
            filterTypes = [];

        if (this.selectedEditType !== 'none') {
          this.clearSelectedTemplates();
          $scope.$broadcast('EntitiesListController::SelectType', {
            typeId: id,
            entityType: this.entityType
          });
        }

        this.selectedTemplates.all = false;
        this.selectedTemplates[id] = (this.selectedTemplates[id]) ? !this.selectedTemplates[id] : true;

        this.filterTypes = '';

        if (this.selectedEditType === 'none') {
          for (template in this.selectedTemplates) {
            if (this.selectedTemplates.hasOwnProperty(template) && this.selectedTemplates[template]) {
              filterTypes.push(template);
            }
          }

          this.filterTypes = filterTypes.join(',');
          this.getQuery();
        }

      },

      clearSelectedTemplates: function() {
        var id;

        for (id in this.selectedTemplates) {
          if (this.selectedTemplates.hasOwnProperty(id)) {
            this.selectedTemplates[id] = false;
          }
        }
      },

      gridDoubleClick: function(item) {
        $state.go('application.entities.detail', { type: $scope.entitiesList.entityType.plural, id: item.entity.id });
      },
      
      onDataGridPaginate: function (newPageNumber, pageSize) {
        var self = $scope.entitiesList;

        self.gridState.updateGridState(newPageNumber, pageSize);
        this.getQuery();
      },
      
      onDataGridSortChange: function (grid, columns) {
        var self = $scope.entitiesList,
            data = columns[0],
            query = {};
            
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
        }

        query = HelpersService.decorate(query, self.gridState.getGridState());
        query = HelpersService.decorate(query, { search: self.searchQuery, type: $state.params.type });
        this.getQuery();
      },

      onSearchTemplatesQueryUpdate: function() {
        $scope.entitiesList.getTemplatesQuery();
      },

      onEntitiesTemplatesCreateCreate: function(e, data) {
        var self = $scope.entitiesList;

        self.templates.push(data.template);
//        self.toggleTemplate(data.template.id);
        self.editTypesDone();
        //self.selectedTemplates = angular.copy(self.cachedSelectedTemplates);

      },

      onEntitiesTemplatesCreateUpdate: function(e, data) {

        var i, ii,
            self = $scope.entitiesList;

        for (i=0,ii=self.templates.length;i<ii;i++) {
          if (self.templates[i].id === data.template.id) {
            self.templates[i] = data.template;
            break;
          }
        }

//        self.toggleTemplate(data.template.id);
        self.editTypesDone();

//        self.selectedTemplates = angular.copy(self.cachedSelectedTemplates);

      },

      onEntitiesTemplatesCreateCancel: function(e, data) {

        var self = $scope.entitiesList;

        self.editTypesDone();

      },

      success: {
        create: function(response) {
          var self = $scope.entitiesList;

          self.currentEntity.id = response.data.payload;
          $state.go('application.entities.edit', { id: self.currentEntity.id, type: self.entityType.plural });
        },

        getTemplates: function(response) {
          var self = $scope.entitiesList;

          self.templates = response.data.payload.list;
          self.templatesGrid.totalItems = response.data.payload.pagination.count;
          self.isListLoaded = true;
        },

        getEntities: function(response) {
          var i, ii,
              self = $scope.entitiesList,
              entities = response.data.payload;

          for (i=0,ii=entities.list.length;i<ii;i++) {
            if (self.entityType.singular === 'personnel') {
              entities.list[i].name = (entities.list[i].firstName || '')+ ' ' + (entities.list[i].lastName || '');
            }
            entities.list[i].entityType = self.entityType.plural;
          }
          self.model = entities.list;
          self.grid.totalItems = entities.pagination.count;
          //self.search();
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;
          self.gridState.updateGridState(null, null, null, null, null, entities.pagination.count);
          $scope.$broadcast('DataGrid::ResizeGrid', {name: self.gridDefinition.options.gridName, datasetLength: self.model.length, totalItems: entities.pagination.count});
        },

        remove: function(response) {
          var self = $scope.entitiesList;
          //self.search();
        }
      },

      error: {
        create: function(response) {
          // TODO: Need to implement
        },

        getTemplates: function(response) {
          var self = $scope.entitiesList;

          self.isListLoaded = true;
        },

        getEntities: function(response) {
          var self = $scope.entitiesList;

          self.isLoaded = true;
        },

        remove: function(response) {}

      }

    };

    $scope.entitiesList.init();

}]);
